import { IBranchInitialState } from "../../../types/master/branchInterface";
import { BranchActionTypes, BranchActions } from "../../actionTypes/master/branchActionTypes";


const initialState: IBranchInitialState = {
  branchList: [],
  branchData: {
    id: 0,
    branch_code: "",
    email: "",
    address: "",
    pincode: "",
    contact_number: "",
    gstin: "",
    contact_person_id: 0,
    hub_id: 0,
    location: "",
    gps_location: "",
    branch_name: "",
    created_by: 0,
    createdAt: "",
    updatedAt: "",
    user: {
      id: 0,
      name: "",
    },
    pincodes: {
      id: 0,
      pincode: "",
      district: {
        id: 0,
        district_name: "",
        state: {
          id: 0,
          state_name: "",
        },
      },
    },
  },
  branchListPageCount: 0,
};

export default function branchReducer(state = initialState, action: BranchActionTypes): IBranchInitialState {
  switch (action.type) {

    case BranchActions.SET_BRANCH_LIST:
      return {
        ...state,
        branchList: action.payload    
      };

    case BranchActions.SET_BRANCH_LIST_PAGE_COUNT:
      return {
        ...state,
        branchListPageCount: action.payload
      };

    case BranchActions.SET_BRANCH_DATA_BY_ID:
      return {
        ...state,
        branchData: action.payload
      }

    default:
      return state;
  }
}
